import React from 'react';
import NavBar from '../../../components/common/navbar';
import SideBar from '../../../components/modules/left_sidebar';
import ReceitasEmCobranca from './ReceitasEmCobranca';
import { Button } from '@progress/kendo-react-buttons'
import $ from 'jquery'
import RightPopModalForm from '../../../components/common/RightPopModalForm';
import services from '../../../services';
const queryString = require('query-string');
var moment = require('moment')
const Administration = false;

/*  configuração de teclas estáticas da página */

let optionMenuArray = [
    {
        sub_menu: [
            {
                linkData: {
                    // filters: {
                    //     Tabs: {
                    //         Período: [
                    //             {
                    //                 key: 'RangePicker',
                    //                 displayKey: "intervalo de datas",
                    //                 inputType: "RangePicker"
                    //             }
                    //         ]
                    //     },
                    //     checkbox: []
                    // },
                    navbarOptionsYear: false,
                    tableName: "general_account",
                    nevdropdown: ["Abertura", "Fecho"],
                    nevdroplabel: "",
                    nevdropplaceholder: "Aberta",
                    popUpTabName: "Consultar Conta",
                    // OpenAndCloseCashier: true,
                    TitleBartitle: "Conta Geral",
                    prevPageName: "",
                    prevPageLink: "",
                    currentPath: "gerfip",
                    nevOptionChange: [
                        // {
                        //     name: 'Emitir Faturas',
                        //     url: 'revenue_faturas',
                        //     tableName:"FaturasEmitir",
                        // },
                        // {
                        //     name: 'Faturas por Liquidar',
                        //     url: 'revenue_faturas',
                        //     tableName:"FaturasLiquidar",
                        // }
                    ],
                    TitleBarlogo: "auditing",
                }
            }
        ]
    }
]


class GeneralAccount extends React.Component {

    /* Primeiro passo na acomodação da classe */

    constructor(props) {
        super(props);
        this.state = this.setLinkDataMethod();
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount = () => {
        this.setState(this.setLinkDataMethod())
    }

    /* Esta função irá chamar automaticamente quando o estado da página mudar  */
    componentDidUpdate = (prevProps) => {
        const parsed = this.props.location.state && this.props.location.state.paramoption ||{};
        let prevParsed = prevProps.location.state && prevProps.location.state.paramoption || {}
        if ( prevParsed.name !== parsed.name && (!parsed.tableName || parsed.back ||  this.state.search !== window.location.search || this.state.tableName !== parsed.tableName)) {
            this.setState(this.setLinkDataMethod())
        }
    }
    // /* Esta função irá chamar automaticamente quando o estado da página mudar */

    // componentDidUpdate = () => {
    //     const parsed = queryString.parse(this.props.location.search);
    //     console.log(parsed.p, this.state.prevPageName)
    //     parsed.p = parsed.p ? parsed.p : ""
    //     parsed.u = parsed.u ? parsed.u : ""
    //     parsed.t = parsed.t ? parsed.t : ""

    //     if (parsed.p !== this.state.linkData.prevPageName) {
    //         let linkData = { ...this.state.linkData };
    //         linkData.prevPageName = parsed.p;
    //         linkData.prevPageLink = parsed.u;
    //         linkData.tableName = parsed.t;
    //         let year = new Date();
    //         year = year.getFullYear();
    //         this.setState({
    //             linkData: linkData,
    //             parsed: parsed
    //         })
    //     }
    // }


    /*  Este método é usado para carregar dados estáticos reletados da página com base nas alterações de url  */

    setLinkDataMethod = () => {
        let parsed = this.props.location.state && this.props.location.state.paramoption || {}
        if(Object.keys(parsed).length === 0 && this.state && this.state.parsed){
            parsed = this.state.parsed
        }
        if(parsed.back){
            parsed = {}
        }
        let topBarMenu = this.props.location && this.props.location.state && this.props.location.state.topBarMenu
        if(topBarMenu){
            this.setState({topBarMenu})
        }
        if(parsed){
            this.setState({parsed})
        }
       // const parsed = queryString.parse(this.props.location.search);
        let mainIndex = 0;
        let subIndex = 0;
        let selectOption = optionMenuArray[mainIndex].sub_menu[subIndex];
        let linkData = selectOption.linkData;
        parsed.name = parsed.name ? parsed.name : ""
        parsed.url = parsed.url ? parsed.url : ""
        parsed.tableName = parsed.tableName ? parsed.tableName : ""
        if (parsed.name) {
            linkData.prevPageName = parsed.name;
            linkData.prevPageLink = parsed.url;
            linkData.tableName = parsed.tableName;
        }


        return {
            noOption: true,
            popUpForm: null,
            linkData: linkData,
            pageOption: "",
            Tab: null,
            parsed: parsed
        }
    }

    /* Sempre que o usuário alterar qualquer opção do front end, este método irá atualizar o url da página de acordo com essa opção  */

    changeOption = (prevPageName, prevPageLink) => {
        let linkData = { ...this.state.linkData }
        linkData.prevPageName = prevPageName;
        linkData.prevPageLink = prevPageLink;
        console.log("OKOK");
        this.setState({
            linkData
        })
    }

    /*  Para renderizar o conteúdo html da página   */

    render() {
           return (
            <div className="dashboard">
                <NavBar date={new Date()} moduleName="Revenue" topBarMenuOption={this.state.topBarMenu} linkData={this.state.linkData} noOption={this.state.noOption} updateNavDropdown={(_row) => this.updateNavDropdown(_row)} />
                <SideBar Administration={Administration} />
                <div className="container-fluid">
                    <ReceitasEmCobranca
                        date={new Date()}
                        noEntitySearch={true}
                        parsed={this.state.parsed}
                        changeOption={(mainIndex, subIndex) => this.changeOption(mainIndex, subIndex)}
                        optionMenuArray={optionMenuArray}
                        topBarMenuOption={this.state.topBarMenu}
                        linkData={this.state.linkData}
                        trans_methods={this.state.trans_methods}
                        tab={"general_account"}
                    />
                </div>
                <button type="hidden" data-toggle="modal" data-target="#popup-modal" className="modelpopup"></button>
                <div className="modal left-popup" id="popup-modal">
                    <div className="modal-dialog modal-lg">
                        {
                            this.state.popUpForm
                        }
                    </div>
                </div>

            </div>

        )
    }
}


export default GeneralAccount;